import React from 'react';

const InvalidTokenPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
            <svg
              className="h-8 w-8 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            この面接リンクは無効か有効期限切れです
          </h1>
          <p className="text-gray-600 mb-6">
            このリンクは以下の理由で使用できません：
          </p>
          <ul className="text-left text-gray-600 mb-6 space-y-2">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>有効期限が切れている</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>面接がキャンセルされている</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>URLが誤っている、または変更されている</span>
            </li>
          </ul>
          <p className="text-sm text-gray-500">
            新しいリンクが必要な場合は、企業の担当者にお問い合わせください。
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvalidTokenPage;

